import { render } from "./AddRentPayment.vue?vue&type=template&id=cd72b590"
import script from "./AddRentPayment.vue?vue&type=script&lang=js"
export * from "./AddRentPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__